// ** React Imports
import React from 'react'

// ** MUI Imports
import { Grid } from '@mui/material'

// ** Child Imports
import AnalyticsDataWidget from '../visualizations/AnalyticsDataWidget'

// ** Util Imports
import { WidgetType } from 'src/lib/types/dashboardAnalytics'
import { 
    initialDiscountPerformanceData, 
    discountPerformanceWidgetConfig } from 'src/assets/AnalyticsConfig'


const DiscountPerformanceWidget: React.FC<WidgetType> = ({ 
    value,
    isLoading,
    isReportView=false
}) => {

    const defaultValue = initialDiscountPerformanceData?.data?.widgetData;
    const fontProperties = [{
        fontSize: 28,
        fontWeight: 600,
        fontColor: "#4D4D4D",
        lineHeight: '32px'
    },
    {
        fontSize: 20,
        fontWeight: 500,
        fontColor: "#4D4D4D",
        lineHeight: '22px'
    },
    {
        fontSize: 20,
        fontWeight: 500,
        fontColor: "#4D4D4D",
        lineHeight: '22px'
    }]
    
    return (
        <>
            <Grid container gap={3} width={"100%"} display={"flex"} flexDirection={"row"} flexWrap={'nowrap'}>
                {(value ?? defaultValue)?.map((summary: any, index: number) => {
                    return (
                        <Grid item display={"flex"} flexDirection={'column'} sx={{ border: `${isReportView ? '2px solid #f0f0f0' : index === 0 ? '2px solid #f0f0f0' : ''}`, borderRadius: '8px', padding: '10px', background: `${index === 0 && !isReportView ? '#FAFAFA' : '#fff'}`, gap: 2 }} flexGrow={1} key={`${index}`}>
                            { summary?.map((pointValue: any, innerIndex: number) => {
                                return (
                                    <AnalyticsDataWidget
                                        key={`${innerIndex}`}
                                        customClass={`${index === 0 && !isReportView ? 'bg-[#FAFAFA]' : ''}`}
                                        removeInnerPadding
                                        widgetType={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.widgetType} 
                                        valueType={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.valueType} 
                                        description={discountPerformanceWidgetConfig?.[index]?.[innerIndex]?.description}
                                        widgetWidth={"100%"}
                                        fontProperties={fontProperties[innerIndex]}
                                        value={pointValue?.x ?? "0"}
                                        isLoading={isLoading}
                                        hideBorders
                                        cardVariant='outlined'
                                    />
                                )
                            })}
                        </Grid>
                    )
                })}
            </Grid>
        </>
  )
}

export default DiscountPerformanceWidget

            